/* Dante Furniture – DH homepage interactions */
(function () {
  if (window.DH) return;
  var DH = (window.DH = {});

  function qsa(root, sel) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Rails with prev/next arrows */
  DH.rails = function (root) {
    qsa(root, '[data-dh-scope]').forEach(function (scope) {
      if (scope.__dhRail) return;
      scope.__dhRail = true;
      var prev = scope.querySelector('[data-dh-prev]');
      var next = scope.querySelector('[data-dh-next]');
      function rail() {
        var all = qsa(scope, '[data-dh-rail]');
        for (var i = 0; i < all.length; i++) { if (all[i].offsetParent !== null) return all[i]; }
        return all[0];
      }
      function update() {
        var r = rail();
        if (!r || !prev || !next) return;
        var max = r.scrollWidth - r.clientWidth - 2;
        prev.disabled = r.scrollLeft <= 2;
        next.disabled = r.scrollLeft >= max;
      }
      function go(dir) {
        var r = rail();
        if (!r) return;
        r.scrollBy({ left: dir * r.clientWidth * 0.85, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      qsa(scope, '[data-dh-rail]').forEach(function (r) {
        r.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      });
      window.addEventListener('resize', update);
      scope.__dhUpdate = update;
      update();
    });
  };

  /* Tabs */
  DH.tabs = function (root) {
    qsa(root, '[data-dh-tabs]').forEach(function (wrap) {
      if (wrap.__dhTabs) return;
      wrap.__dhTabs = true;
      var tabs = qsa(wrap, '[role="tab"]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
            t.tabIndex = on ? 0 : -1;
            var p = wrap.closest('[data-dh-scope]').querySelector('[id="' + t.getAttribute('aria-controls') + '"]');
            if (p) p.hidden = !on;
          });
          var scope = wrap.closest('[data-dh-scope]');
          if (scope && scope.__dhUpdate) scope.__dhUpdate();
        });
        tab.addEventListener('keydown', function (e) {
          var i = tabs.indexOf(tab);
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
            n.focus(); n.click();
          }
        });
      });
    });
  };

  /* Countdown */
  DH.countdowns = function (root) {
    qsa(root, '[data-dh-countdown]').forEach(function (el) {
      if (el.__dhCount) return;
      el.__dhCount = true;
      var end = new Date(el.getAttribute('data-dh-countdown').replace(' ', 'T')).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var u = {
        d: el.querySelector('[data-u="d"]'), h: el.querySelector('[data-u="h"]'),
        m: el.querySelector('[data-u="m"]'), s: el.querySelector('[data-u="s"]')
      };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { el.hidden = true; clearInterval(t); return; }
        u.d.textContent = Math.floor(diff / 864e5);
        u.h.textContent = pad(Math.floor(diff % 864e5 / 36e5));
        u.m.textContent = pad(Math.floor(diff % 36e5 / 6e4));
        u.s.textContent = pad(Math.floor(diff % 6e4 / 1e3));
      }
      var t = setInterval(tick, 1000);
      tick();
    });
  };

  /* Copy discount code */
  DH.copy = function (root) {
    qsa(root, '[data-dh-copy]').forEach(function (btn) {
      if (btn.__dhCopy) return;
      btn.__dhCopy = true;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-dh-copy');
        var done = function () {
          btn.classList.add('is-copied');
          setTimeout(function () { btn.classList.remove('is-copied'); }, 1800);
        };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      });
    });
  };

  /* Editorial read more */
  DH.more = function (root) {
    qsa(root, '[data-dh-more]').forEach(function (btn) {
      if (btn.__dhMore) return;
      btn.__dhMore = true;
      btn.addEventListener('click', function () {
        var box = btn.closest('.dh-edit');
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
  };

  /* Open now badge for showrooms: data-dh-hours="0:closed|1:0900-1730|..." (0 = Sunday) */
  DH.openNow = function (root) {
    qsa(root, '[data-dh-hours]').forEach(function (el) {
      var map = {};
      el.getAttribute('data-dh-hours').split('|').forEach(function (p) {
        var kv = p.split(':'); if (kv.length === 2) map[kv[0].trim()] = kv[1].trim();
      });
      var now = new Date();
      try { now = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/London' })); } catch (e) {}
      var today = map[String(now.getDay())];
      var mins = now.getHours() * 60 + now.getMinutes();
      var open = false;
      if (today && today !== 'closed') {
        var r = today.split('-');
        var a = parseInt(r[0].slice(0, 2), 10) * 60 + parseInt(r[0].slice(2), 10);
        var b = parseInt(r[1].slice(0, 2), 10) * 60 + parseInt(r[1].slice(2), 10);
        open = mins >= a && mins < b;
      }
      el.classList.toggle('is-open', open);
      el.textContent = open ? el.getAttribute('data-open') : el.getAttribute('data-closed');
      el.hidden = false;
    });
  };

  /* Reveal on scroll */
  DH.reveal = function (root) {
    var els = qsa(root, '.dh-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  };

  function compactChatLabel() {
    if (!document.body.classList.contains('template-index')) return;
    if (window.tidioChatApi && window.tidioChatApi.setFeatures) {
      window.tidioChatApi.setFeatures({ widgetLabelStatus: false });
    }
    var host = document.getElementById('tidio-chat');
    var root = host && host.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('[data-dh-chat-style]')) {
      var style = document.createElement('style');
      style.setAttribute('data-dh-chat-style', '');
      style.textContent = '.widgetLabel{display:none!important}#tidio-chat-root:has(#button.chat-closed){width:96px!important}';
      root.appendChild(style);
    }
    return true;
  }
  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', compactChatLabel);
    if (window.tidioChatApi.getStatus && window.tidioChatApi.getStatus() !== null) compactChatLabel();
  } else {
    document.addEventListener('tidioChat-ready', compactChatLabel);
  }
  if (document.body.classList.contains('template-index') && !compactChatLabel()) {
    var chatObserver = new MutationObserver(function () {
      if (compactChatLabel()) chatObserver.disconnect();
    });
    chatObserver.observe(document.body, { childList: true, subtree: true });
    window.setTimeout(function () { chatObserver.disconnect(); }, 20000);
  }

  DH.init = function (root) {
    root = root || document;
    DH.rails(root); DH.tabs(root); DH.countdowns(root); DH.copy(root); DH.more(root); DH.openNow(root); DH.reveal(root);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { DH.init(); });
  else DH.init();
  document.addEventListener('shopify:section:load', function (e) { DH.init(e.target); });
})();
